"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <h1 className="text-6xl font-bold">404</h1>
      <p className="text-xl text-muted-foreground">
        Sorry, the page you visited does not exist.
      </p>
      <Link href="/">
        <Button>Back Home</Button>
      </Link>
    </div>
  );
}
